import JemConfigurationSerializer from 'eflex/serializers/jem-configuration';

export default class StationLoadJemConfigurationSerializer extends JemConfigurationSerializer {}
